<div class="view-container">
  <div class="renderers">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px"
          fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Renderers</label>
        </div>

        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
              <mat-form-field class="accent">
                <mat-label>Search renderers by name</mat-label>
                <input matInput type="text" [(ngModel)]="searchTerm" (keyup.enter)="loadRenderers()"
                  (keyup.esc)="searchTerm=''; loadRenderers()" name="searchTerm" placeholder="Search Name">
                <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear"
                  (click)="searchTerm=''; loadRenderers()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <div fxLayout="row" fxLayoutGap="10px">
                <mat-checkbox [(ngModel)]="isBusyOnly" (change)="updateParams()">Busy Only</mat-checkbox>
                <button type="submit" mat-flat-button color="primary" (click)="loadRenderers()" matTooltip="Search"
                  [class.button-spinner]="loading" [disabled]="loading">
                  <mat-icon>search</mat-icon> Search
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="contrast w-100" *ngFor="let item of renderersDataSource.data" [class.banner-error]="item?.disabled"
          [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="start start" fxLayout="row wrap">
            <div fxFlex="100" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
              <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="5px">
                <strong [ngClass.lt-sm]="{'card-title': true}" [matTooltip]="item?.id" [innerHtml]="item?.name | highlight: searchTerm"></strong>
                <img *ngIf="getOSIcon(item)"
                  [src]="getOSIcon(item)?.iconPath" 
                  [matTooltip]="getOSIcon(item)?.tooltip"
                  class="os-icon"
                  alt="OS icon">
                <mat-chip-list *ngIf="item?.rendererPool?.name">
                  <mat-chip matTooltip="Member of {{ item.rendererPool.name }}">
                    <span>{{ item.rendererPool.name }}</span>
                  </mat-chip>
                </mat-chip-list>
              </div>
              <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="18px">
                <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                  <p><small>Health Check</small></p>
                  <div class="text-center" [class.text-danger]="isOlderThan2Minutes(item.dateLastHealthCheck)"
                    [ngClass.gt-xs]="{'m-l-5': true}">{{ getHealthCheckDisplay(item.dateLastHealthCheck) }}</div>
                  <div fxHide.lt-sm class="m-l-5 m-r-5">|</div>
                  <p><small>busy</small></p>
                  <div class="text-center text-{{ getRendererStatusColour(item?.rendererStatus) }}" [ngClass.gt-xs]="{'m-l-5': true}">{{ getRendererStatus(item?.rendererStatus) }}</div>
                  <div fxHide.lt-sm class="m-l-5 m-r-5">|</div>
                  <p><small>Gpu</small></p>
                  <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">{{ shortenGpu(item?.gpu) }}</div>
                  <div fxHide.lt-sm class="m-l-5 m-r-5">|</div>
                  <p><small>Storage</small></p>
                  <div class="text-center {{ getStorageClass(item) }}" [ngClass.gt-xs]="{'m-l-5': true}">{{ storageRemaining(item) }}</div>
                  <div fxHide.lt-sm class="m-l-5 m-r-5">|</div>
                  <p><small>Version</small></p>
                  <div class="text-center" [ngClass.gt-xs]="{'m-l-5': true}">{{ item?.launcherVersion }}</div>
                </div>
                <div fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
                  <button mat-icon-button color="accent" aria-label="View Renderer" matTooltip="View Renderer"
                    (click)="onViewRenderer(item.id)">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <recipe-event-summary-card fxFlex="100" *ngFor="let summary of item.recipeEventSummaries" [recipeEventSummary]="summary">
            </recipe-event-summary-card>
          </mat-card-content>
        </mat-card>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
            [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
            (page)="onPageChange($event)">
          </mat-paginator>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>

